export const blockIconsDeviceSummarize = (
	<span className='material-symbols-outlined'>summarize</span>
);
